import { NavLink } from 'react-router-dom';
import { Home, CalendarDays, Users, Map, MoreHorizontal } from 'lucide-react';
import { useAuth } from '../stores/auth';
import { useVomPermissions } from '../hooks/useVomPermissions';
import { useShowPhi } from '../hooks/useFeatureFlags';
import { phiText } from '../lib/phiConfig';

const baseTabs = [
  { to: '/dashboard', icon: Home, label: 'Home', testid: 'bottom-nav-home' },
  { to: '/schedule', icon: CalendarDays, label: phiText('Schedule', 'Task Calendar'), testid: 'bottom-nav-schedule' },
  { to: '/patients', icon: Users, label: 'Patients', testid: 'bottom-nav-patients' },
  { to: '/map', icon: Map, label: 'Map', testid: 'bottom-nav-map' },
  { to: '/more', icon: MoreHorizontal, label: 'More', testid: 'bottom-nav-more' },
];

const vomTabs = [
  { to: '/vom', icon: Home, label: 'Home', testid: 'bottom-nav-home' },
  { to: '/schedule', icon: CalendarDays, label: phiText('Schedule', 'Task Calendar'), testid: 'bottom-nav-schedule', feature: 'schedule' },
  { to: '/patients', icon: Users, label: 'Patients', testid: 'bottom-nav-patients', feature: 'patients' },
  { to: '/map', icon: Map, label: 'Map', testid: 'bottom-nav-map', feature: 'schedule' },
  { to: '/more', icon: MoreHorizontal, label: 'More', testid: 'bottom-nav-more' },
];

export function BottomNav() {
  const role = useAuth(s => s.profile?.role);
  const orgType = useAuth(s => s.org?.type);
  const vomPerms = useVomPermissions();
  const showPhi = useShowPhi();
  const rawTabs = role === 'virtual_ops_manager' ? vomTabs : baseTabs;
  // Patients tab is PHI — fail-closed on the master PHI toggle. Map is home-health only.
  const tabs = rawTabs.filter(t => (!t.feature || vomPerms.hasAny(t.feature)) && (t.to !== '/patients' || showPhi) && (t.to !== '/map' || orgType === 'home_health'));
  return (
    <nav
      data-testid="bottom-nav"
      className="mobile-only fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur border-t border-[var(--color-border)] shadow-[0_-10px_30px_rgba(15,42,74,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-stretch justify-around max-w-md mx-auto">
        {tabs.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            aria-label={t.label}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-0.5 flex-1 py-2.5 min-h-[56px] text-[10.5px] font-medium transition-colors ${
                isActive ? 'text-[#0F2A4A]' : 'text-[var(--color-muted)] hover:text-[#0F2A4A]'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <t.icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
                <span>{t.label}</span>
                {isActive && <span className="absolute top-0 h-0.5 w-8 bg-[var(--color-teal)] rounded-full" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
